import JassEnum from './enum';

/**
 * type gamespeed
 */
export default class JassGameSpeed extends JassEnum {}
